import api from "../../infra/api";

class SolicitacaoAcesso {
    async listar (codigoResp, filtro) {
        const response = await api({
            method: "GET",
            url: filtro.trim() === ""
                ? `/api/v1/SolicitacaoDeAcesso?page=1&start=0&limit=999&fields=["Id","Situacao","SituacaoObra","Protocolo","PotenciaInstalada","Nome","Inscricao","Endereco","DataCadastro","PrazoAnalise","CodigoUC", "CodigoResponsavelTec", "TipoInscricao","PossuiPrazoAdequacao","PrazoAdequacao","TipoGeracao.Descricao","Complemento","PrazoDocumentacao","DocumentacaoAprovada", "VGoObraPrazo"]&sort=[{"property":"Id","direction":"DESC"}]&filter=[{"property":"CodigoResponsavelTec","value":"${codigoResp}","and":false}]` 
                : `/api/v1/SolicitacaoDeAcesso?page=1&start=0&limit=999&fields=["Id","Situacao","SituacaoObra","Protocolo","PotenciaInstalada","Nome","Inscricao","Endereco","DataCadastro","PrazoAnalise","CodigoUC", "CodigoResponsavelTec", "TipoInscricao","PossuiPrazoAdequacao","PrazoAdequacao","TipoGeracao.Descricao","Complemento","PrazoDocumentacao","DocumentacaoAprovada", "VGoObraPrazo"]&sort=[{"property":"Id","direction":"DESC"}]&filter=[{"property":"CodigoResponsavelTec","value":"${codigoResp}","and":true,"not":false}, {"property":"Nome","operator":"containsall","value":"${filtro}","and":true}]`
        });

        return response.data;
    }

    async listarCFiltros(codigoResp, pesquisaGeral) {
        let url = `/api/v1/SolicitacaoDeAcesso?page=1&start=0&limit=999&fields=["Id","Situacao","SituacaoObra","Protocolo","PotenciaInstalada","Nome","Inscricao","Endereco","DataCadastro","PrazoAnalise","CodigoUC", "CodigoResponsavelTec", "TipoInscricao","PossuiPrazoAdequacao","PrazoAdequacao","TipoGeracao.Descricao","Complemento","PrazoDocumentacao","DocumentacaoAprovada", "VGoObraPrazo"]&sort=[{"property":"Id","direction":"DESC"}]&filter=[{"property":"CodigoResponsavelTec","value":"${codigoResp}","and":true,"not":false}]`;

        if(pesquisaGeral.trim() !== "") {
            url = url.slice(0, -1);
            url += `,{"property":"Nome","operator":"containsall","value":"${pesquisaGeral}"},{"property":"Inscricao","operator":"containsall","value":"${pesquisaGeral}","and":false},{"property":"Protocolo","value":"${pesquisaGeral}","and":false},{"property":"CodigoUC","value":"${pesquisaGeral}","and":false},{"property":"Id","value":"${pesquisaGeral}","and":false}]`;
        } 

        const response = await api({
            method: "GET",
            url: url
        });

        return response.data;
    }

    async listarCfeSituacaoOuData(codigoResp, pesquisaGeral, codigo, situacao, tipoDataFiltro, dataInicial, dataFinal) {
        let filter = this.retornaFilterDeAcordoComFiltros(codigoResp, pesquisaGeral, codigo, situacao, tipoDataFiltro, dataInicial, dataFinal);
        let url = filter.trim() === "" ?
                    `/api/v1/SolicitacaoDeAcesso?page=1&start=0&limit=999&fields=["Id","Situacao","SituacaoObra","Protocolo","PotenciaInstalada","Nome","Inscricao","Endereco","DataCadastro","PrazoAnalise","CodigoUC", "CodigoResponsavelTec", "TipoInscricao","PossuiPrazoAdequacao","PrazoAdequacao","TipoGeracao.Descricao","Complemento","PrazoDocumentacao","DocumentacaoAprovada", "VGoObraPrazo"]&sort=[{"property":"Id","direction":"DESC"}]&filter=[{"property":"CodigoResponsavelTec","value":"${codigoResp}","and":true,"not":false}]` :
                    `/api/v1/SolicitacaoDeAcesso?page=1&start=0&limit=999&fields=["Id","Situacao","SituacaoObra","Protocolo","PotenciaInstalada","Nome","Inscricao","Endereco","DataCadastro","PrazoAnalise","CodigoUC", "CodigoResponsavelTec", "TipoInscricao","PossuiPrazoAdequacao","PrazoAdequacao","TipoGeracao.Descricao","Complemento","PrazoDocumentacao","DocumentacaoAprovada", "VGoObraPrazo"]&sort=[{"property":"Id","direction":"DESC"}]&filter=${filter}`;

        const response = await api({
            method: "GET",
            url: url
        });

        return response.data;
    }

    retornaFilterDeAcordoComFiltros(codigoResp, pesquisaGeral, codigo, situacao, tipoDataFiltro, dataInicial, dataFinal) {
        let temPesquisaGeral = pesquisaGeral.trim() !== "";
        
        if(temPesquisaGeral) {
            let filtroSituacaoDatas = this.handleFiltrosSituacaoOuDatas(codigoResp, codigo, situacao, tipoDataFiltro, dataInicial, dataFinal);
            let filtroFinal = "," + filtroSituacaoDatas.slice(1);

            return `[{"property":"Nome","operator":"containsall","value":"${pesquisaGeral}","and":false},{"property":"Inscricao","operator":"containsall","value":"${pesquisaGeral}","and":false},{"property":"Protocolo","operator":"equal","value":"${pesquisaGeral}","and":false},{"property":"CodigoUC","operator":"equal","value":"${pesquisaGeral}","and":false},{"property":"CodigoResponsavelTec","operator":"equal","value":${codigoResp},"and":true,"not":false}` + filtroFinal;
        } else {
            return this.handleFiltrosSituacaoOuDatas(codigoResp, codigo, situacao, tipoDataFiltro, dataInicial, dataFinal);
        }
    }

    handleFiltrosSituacaoOuDatas(codigoResp, codigo, situacao, tipoDataFiltro, dataInicial, dataFinal) {
        let temSituacaoInformada = situacao.length > 0;
        let temPeriodoInformado = (dataInicial && dataInicial.toLocaleDateString() !== "") && (dataFinal && dataFinal.toLocaleDateString() !== "");
        let arraySituacaoFormatada = JSON.stringify(situacao);
        let campoParaFiltrarData = (tipoDataFiltro === "data-cadastro") ? "DataCadastro" : "DataEnvioSolicitacao";

        if(temSituacaoInformada && !temPeriodoInformado) {
            return `[{"property":"Id","operator":"equal","value":"${codigo}","and":true,"not":false},{"property":"CodigoResponsavelTec","operator":"equal","value":"${codigoResp}","and":true,"not":false},{"property":"Situacao","operator":"in","value":${arraySituacaoFormatada},"and":true,"not":false}]`
        } else if(!temSituacaoInformada && temPeriodoInformado) {
            return `[{"property":"Id","operator":"equal","value":"${codigo}","and":true,"not":false},{"property":"CodigoResponsavelTec","operator":"equal","value":"${codigoResp}","and":true,"not":false},{"property":"${campoParaFiltrarData}","operator":"greaterOrEqual","value":"${dataInicial.toLocaleDateString()}","and":true},{"property":"${campoParaFiltrarData}","operator":"lessOrEqual","value":"${dataFinal.toLocaleDateString()}","and":true}]`
        } else {
            return `[{"property":"Id","operator":"equal","value":"${codigo}","and":true,"not":false},{"property":"CodigoResponsavelTec","operator":"equal","value":"${codigoResp}","and":true,"not":false},{"property":"Situacao","operator":"in","value":${arraySituacaoFormatada},"and":true,"not":false},{"property":"${campoParaFiltrarData}","operator":"greaterOrEqual","value":"${dataInicial ? dataInicial.toLocaleDateString() : "01/01/1900"}","and":true},{"property":"${campoParaFiltrarData}","operator":"lessOrEqual","value":"${dataFinal ? dataFinal.toLocaleDateString() : "01/01/1900"}","and":true}]`
        }
    }

    montaQueryFilterListarSolicAcesso(codigoResp, pesquisaGeral, situacao) {
        return `/api/v1/SolicitacaoDeAcesso?page=1&start=0&limit=999&fields=["Id","Situacao","SituacaoObra","Protocolo","PotenciaInstalada","Nome","Inscricao","Endereco","DataCadastro","PrazoAnalise","CodigoUC","TipoInscricao","PossuiPrazoAdequacao","PrazoAdequacao","TipoGeracao.Descricao","Complemento","PrazoDocumentacao","DocumentacaoAprovada", "VGoObraPrazo"]&sort=[{"property":"Id","direction":"DESC"}]&filter=[{"property":"Id","operator":"equal","value":"${pesquisaGeral}","and":false},{"property":"Nome","operator":"containsall","value":"${pesquisaGeral}","and":false},{"property":"Inscricao","operator":"containsall","value":"${pesquisaGeral}","and":false},{"property":"Protocolo","operator":"equal","value":"${pesquisaGeral}","and":false},{"property":"CodigoUC","operator":"equal","value":"${pesquisaGeral}","and":false},{"property":"CodigoResponsavelTec","operator":"equal","value":${codigoResp},"and":true,"not":false},{"property":"Situacao","operator":"in","value":${situacao},"and":true,"not":false}]`;
    }

    async Inserir (dto) {
        const response = await api({
            method: "POST",
            url: "api/v1/SolicitacaoDeAcesso",
            data: JSON.stringify(dto)
        });

        return response.data;
    }

    async RecuperarParaEditar(codigoSolic) {
        const response = await api({
            method: "GET",
            url: `/api/v1/SolicitacaoDeAcesso/${codigoSolic}/RecuperarParaEditar`,
        });

        return response.data;
    }

    async RecuperarEquipamentosSolicCalculandoPotencia(codigoSolic) {
        const response = await api({
            method: "GET",
            url: `/api/v1/SolicitacaoDeAcesso/${codigoSolic}/RecuperarEquipamentosSolicCalculandoPotencia`,
        });

        return response.data;
    }

    async Editar (dto) {
        const response = await api({
            method: "PUT",
            url: `api/v1/SolicitacaoDeAcesso/${dto.Id}`,
            data: JSON.stringify(dto)
        });

        return response.data;
    }

    async RecuperarParticipantesDaSolicitacao (codigoSolicitacao) {
        const response = await api({
            method: "GET",
            url: `/api/v1/SolicitacoesDeAcessoParticipantes?page=1&start=0&limit=999&filter=[{"property":"CodigoSolicitacaoAcesso","operator":"equal","value":"${codigoSolicitacao}","and":"true"}]`
        });

        return response.data;
    }

    async InserirParticipantes (dto) {
        const response = await api({
            method: "POST",
            url: "/api/v1/SolicitacoesDeAcessoParticipantes/",
            data: dto
        });

        return response.data;
    }

    async RemoverParticipanteDaSolicitacao(codigoParticipante) {
        const response = await api({
            method: "DELETE",
            url: `/api/v1/SolicitacoesDeAcessoParticipantes/${codigoParticipante}`,
        });

        return response.data;
    }

    async RecuperarEquipamentosDaSolicitacao (codigoSolicitacao) {
        const response = await api({
            method: "GET",
            // url: `/api/v1/SolicitacaoDeAcessoEquipamentos?page=1&start=0&limit=999&filter=[{"property":"CodigoSolicitacaoAcesso","operator":"equal","value":"${codigoSolicitacao}","and":"true"}]`
            url: `/api/v1/SolicitacaoDeAcessoEquipamentos?page=1&start=0&limit=999&filter=[{"property":"CodigoSolicitacaoAcesso","operator":"equal","value":"${codigoSolicitacao}","and":true,"not":false}]`
        });

        return response.data;
    }

    async InserirEquipamentos (dto) {
        const response = await api({
            method: "POST",
            url: "/api/v1/SolicitacaoDeAcessoEquipamentos/",
            data: dto
        });

        return response.data;
    }

    async RemoverEquipamentoDaSolicitacao(codigoParticipante) {
        const response = await api({
            method: "DELETE",
            url: `/api/v1/SolicitacaoDeAcessoEquipamentos/${codigoParticipante}`,
        });

        return response.data;
    }

    async InserirDocumentoNaSolicitacao(form) {
        const response = await api ({
            method: "POST",
            url: "/api/v1/SolicitacaoDeAcesso/AdicionarAnexoNaSolicitacao",
            headers: {
                "Content-Type": "multipart/form-data",
            },
            data: form
        });

        return response.data;
    }

    async RecuperarDadosDoConsumidor(dto) {
        const response = await api({
            method: "POST",
            url: "api/v1/UC/DadosDoConsumidorSol",
            data: JSON.stringify(dto)
        });

        return response.data;
    }

    async ArquivarSolicitacaoPeloResponsavelTecnico(dto) {
        const response = await api({
            method: "PUT",
            url: "api/v1/SolicitacaoDeAcesso/ArquivarSolicitacaoPeloResponsavelTecnico",
            data: JSON.stringify(dto)
        });

        return response.data;
    }

    async RecuperarArquivamento (codigoSolicitacao) {
        const response = await api({
            method: "GET",
            url: `api/v1/SolicitacaoDeAcesso/RecuperarArquivamento/${codigoSolicitacao}`
        });
        
        return response.data;
    }

    async InformarInicioInstalacao(form) {
        const response = await api({
            method: "POST",
            url: `api/v1/SolicitacaoDeAcesso/InformarInicioInstalacao`,
            headers: {
                "Content-Type": "multipart/form-data",
            },
            data: form
        });

        return response.data;
    }

    async RecuperarInicioDaInstalacao(codigoSolicitacaoAcesso) {
        const response = await api({
            method: "GET",
            url: `api/v1/SolicitacaoDeAcesso/${codigoSolicitacaoAcesso}/RecuperarInicioDaInstalacao`
        });

        return response.data;
    }

    async VisualizarCartaDeInstalacao(codigoSolicitacaoAcesso) {
        const response = await api({
            method: "POST",
            url: `api/v1/SolicitacaoDeAcesso/VisualizarCartaDeInstalacao/${codigoSolicitacaoAcesso}`
        });

        return response.data;
    }

    async RealizarDownloadDocumento (codigoDocumento) {
        const response = await api({
            method: "POST",
            url: "api/v1/SolicitacaoDeAcesso/RealizarDownloadDocumento",
            data: {
                CodigoDocumento: codigoDocumento
            }
        });

        return response.data;
    }

    async RecuperarSolicitacao (codigoSolicitacao) {
        const response = await api({
            method: "GET",
            url: `api/v1/SolicitacaoDeAcesso/${codigoSolicitacao}/RecuperarSolicitacao`
        });
        
        return response.data;
    }

    async AtualizarOrdemAbatimentoEntreOsParticipantes (dto) {
        const response = await api({
            method: "PUT",
            url: `api/v1/SolicitacoesDeAcessoParticipantes/AtualizarOrdemAbatimentoEntreOsParticipantes`,
            data: JSON.stringify(dto)
        });

        return response.data;
    }

    async RemoverTodosParticipantesSolicitacao(codigoSolicitacao) {
        const response = await api({
            method: "DELETE",
            url: `/api/v1/SolicitacoesDeAcessoParticipantes/RemoverTodosParticipantesSolicitacao/${codigoSolicitacao}`,
        });

        return response.data;
    }

    async RemoverDocumento(codigoDocumento) {
        const response = await api({
            method: "DELETE",
            url: `api/v1/SolicitacaoDeAcesso/RemoverAnexoDocs/${codigoDocumento}`
        });

        return response.data;
    }
}

export default new SolicitacaoAcesso;